import { createReducer } from "@reduxjs/toolkit";
import {
  getCompletedQuestionaryListSuccess,
  loadingList,
} from "./completedQuestionaryActions";

export interface IQuestionaryState {
  cQuestionaryList: Array<any>;
  dataCount: number;
  isLoading: boolean;
  ProcedureId: number;
}

const initialState: IQuestionaryState = {
  cQuestionaryList: [],
  dataCount: 0,
  isLoading: false,
  ProcedureId: 0,
};

export const completedQuestionnaireReducer = createReducer(
  initialState,
  (builder) => {
    builder
      .addCase(getCompletedQuestionaryListSuccess, (state, action) => {
        state = {
          ...state,
          cQuestionaryList: action.payload?.data,
          dataCount: action.payload?.dataCount,
        };
        return state;
      })

      .addCase(loadingList, (state, action) => {
        state = {
          ...state,
          isLoading: action.payload,
        };
        return state;
      });
  }
);
